import { render, staticRenderFns } from "./cartIcon.vue?vue&type=template&id=4f0a56b8&scoped=true"
import script from "./cartIcon.vue?vue&type=script&lang=js"
export * from "./cartIcon.vue?vue&type=script&lang=js"
import style0 from "./cartIcon.vue?vue&type=style&index=0&id=4f0a56b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0a56b8",
  null
  
)

export default component.exports